<script setup lang="ts">
withDefaults(
  defineProps<{
    text?: string
  }>(),
  {
    text: '',
  },
)
</script>

<template>
  <div class="base-field-info ml-1 mt-1 w-full text-sm text-gray-300">
    <p class="m-0">
      {{ text }}
    </p>
  </div>
</template>
